const getOrderDate = (date: string):string => date.slice(0, 10);


export default getOrderDate;
